import { useDialog } from '@react-aria/dialog';
import { FocusScope } from '@react-aria/focus';
import { DismissButton, useModal, useOverlay } from '@react-aria/overlays';
import { mergeProps } from '@react-aria/utils';
import React, { useContext, useRef } from 'react';
import { HeaderAccountLoginPage } from 'src/components/Header/components/HeaderAccountSection/HeaderAccountLoginPage';
import {
  HeaderAccountProfileSection,
} from 'src/components/Header/components/HeaderAccountSection/HeaderAccountProfileSection';
import { LoginContext } from 'src/lib/LoginContext';

export const HeaderAccountPopover = ({ onClose, isOpen }) => {
  const ref = useRef(null!);
  const { overlayProps } = useOverlay({
    onClose,
    isOpen,
    isDismissable: true,
    shouldCloseOnBlur: true,
    shouldCloseOnInteractOutside: (element: HTMLElement) => {
      if(element.closest('[data-dont-close-account-popover="true"]')) {
        return false;
      }
      if(element.closest('[data-allow-press-while-closing-account-popover="true"]')) {
        setTimeout(() => onClose(), 100);
        return false;
      }
      if(element.closest('[data-dont-close-mega-menu="true"]')) {
        onClose();
        return false;
      }
      if(element.closest('[data-allow-press-while-closing-mega-menu="true"]')) {
        setTimeout(() => onClose(), 100);
        return false;
      }
      return true;
    },
  }, ref);
  const { dialogProps } = useDialog({}, ref);
  const { modalProps } = useModal();

  const { isLoggedIn } = useContext(LoginContext);

  const currentPage = isLoggedIn ? 'account' : 'login';

  if(!isOpen) return <></>;

  return (
    <FocusScope contain restoreFocus autoFocus>
      <div {...mergeProps(dialogProps, modalProps, overlayProps)} ref={ref} className={'absolute z-50 right-0 top-[calc(100%+14px)] bg-surface-dark w-full max-w-[420px] focus:outline-0'}>
        <div className='bg-surface-dark shadow-md shadow-black/50 py-5 flex flex-col gap-4'>
          <HeaderAccountProfileSection id='header-account-popover-profile-section' onClose={onClose} currentPage={currentPage} noBorderBottom={currentPage !== 'login'}/>
          {currentPage === 'login'
              && <div className='px-4 flex flex-col gap-4'>
                <HeaderAccountLoginPage id={'header-account-popover-login'} onClose={onClose}/>
              </div>
          }
          <DismissButton onDismiss={onClose}/>
        </div>
      </div>
    </FocusScope>
  );
};
